import {
  Chart,
  ChartAxisDefaults,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { useEffect, useState } from "react";
import { chartColors } from "../../../utils/application.utils";
import moment from "moment";

const WeightStats = ({ statsData }: any) => {
  const [projects, setProjects] = useState<any[]>();
  const [weightCounts, setWeightCounts] = useState<number[]>([
    2, 4, 10, 5, 5, 2, 3, 4, 0, 1,
  ]);

  useEffect(() => {
    const data = Array.from(new Set(statsData.map((x: any) => x.name))).sort();

    const projects = Array.from(new Set(data.map((x: any) => x)));
    setProjects(projects);

    const weightList = statsData
      .map((proj: any) => {
        return {
          project: proj.name,
          count: (proj.weight / 1000).toFixed(3),
        };
      })
      .map((x: any) => x.count);

    setWeightCounts(weightList);
  }, [statsData]);

  return (
    <>
      <div className="sm:px-4 px-3  flex-1">
        <Chart style={{ height: "300px" }}>
          <ChartLegend
            visible={false}
            position="bottom"
            orientation="horizontal"
            labels={{ font: "10px Cabin, sans-serif" }}
          />
          <ChartAxisDefaults labels={{ format: "##,#" }} />
          <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={projects}
              majorGridLines={{ visible: false }}
              minorGridLines={{ visible: false }}
            ></ChartCategoryAxisItem>
          </ChartCategoryAxis>
          <ChartSeries>
            <ChartSeriesItem
              type="column"
              data={weightCounts}
              name="Weight (Ton)"
              color={"#002854"}
              tooltip={{ visible: true }}
            />
          </ChartSeries>
        </Chart>
      </div>
    </>
  );
};
export default WeightStats;
